import React from 'react';
import PortalOverlay from './PortalOverlay';

export type PortalModalTriggerProps = {
  name: string;
  immediateOpen?: boolean;
  renderModal: (requestClose: () => void) => React.ReactNode;
  renderTrigger?: (requestOpen: () => void) => React.ReactNode;
  onOpen?: () => void;
  onClose?: () => void;
};

export default function PortalModalTrigger({
  name,
  renderModal,
  renderTrigger,
  immediateOpen = false,
  onOpen,
  onClose,
}: PortalModalTriggerProps) {
  const [modalOpen, setModalOpen] = React.useState(immediateOpen);

  const handleOpen = () => {
    setModalOpen(true);
    onOpen?.();
  };
  const handleClose = () => {
    setModalOpen(false);
    onClose?.();
  };

  return (
    <React.Fragment>
      {renderTrigger?.(handleOpen)}
      {modalOpen && (
        <PortalOverlay
          name={name}
          onBackdropClick={handleClose}
        >
          {renderModal(handleClose)}
        </PortalOverlay>
      )}
    </React.Fragment>
  );
}
